module.exports = __webpack_public_path__ + "media/src/images/icon/map-069ab176010fd1d2540cd5af8d8adb89.png";